module.exports = __webpack_public_path__ + "img/auto-sliding-carousel-popup.6fdc8a5e.png";